import PageTableHeader from "../../../components/pageTableHeader/pageTableHeader";
import CommonTable from "../../../components/table/table";
import BottomDrawer from "../../common/drawer/bottomDrawer";
import { useCommonFetch } from "../../../../hooks/useCommonFetch";
import {
  deleteDepartment,
  getDepartmentList,
  createDepartment,
  updateDepartment,
} from "../../../../services/workspace/department.service";
import { useState, useMemo } from "react";
import CommonForm from "../../../components/form/form";
import {
  createActionButtons,
  commonConditions,
} from "../../../../utils/actionButtonHelpers";
import {
  createDataTransformer,
  presetTransformers,
} from "../../../../utils/dataTransformers";
import { useFilterOptions } from "../../../../hooks/useFilterOptions";

const actions_type = {
  DELETE: "DELETE",
  ADD_EDIT: "ADD_EDIT",
};

const items = [{ label: "Manage Department", path: "" }];
const customCases = {
  0: { label: "Inactive", color: "text-red-500 text-sm", bg: "bg-red-500" },
  1: { label: "Active", color: "text-green-600 text-sm", bg: "bg-green-600" },
};

const ManageDepartment = () => {
  const [isEditValue, setIsEditValue] = useState(null);
  // Fetch departments for parent department dropdown
  const { departments, departmentsLoading } = useFilterOptions(['departments']);
  
  // const [showDeleteForInactive, setShowDeleteForInactive] = useState(false);
  const {
    loading,
    data: tableData,
    total: totalData,
    currentPage,
    search,
    selectedId,
    action,
    handleSearchChange,
    handlePageChange,
    openModal,
    closeModal,
    handleCreate,
    handleUpdate,
    handleDelete,
    // New sorting helpers
    sortingUIProps,
  } = useCommonFetch(getDepartmentList, {
    dataPath: "department.data",
    totalPath: "department.meta.total",
    errorMessage: "Failed to fetch department data!",
    debounceDelay: 500,
    // Dynamic sorting configuration
    sortingOptions: [
      { label: "Name", field: "name" },
      { label: "Date", field: "created_at" },
    ],
    sortingModule: "department",
    orderParamNames: {
      orderByKey: "order_by",
      orderTypeKey: "order_type",
      includeDisabledKey: "includeDisabled",
    },
    sortingDisableText: "Disabled",
    sortingShowDisableToggle: false,
    // Optimized data transformer using utility functions
    dataTransformer: createDataTransformer(
      presetTransformers.department(customCases),
      () =>
        createActionButtons(
          {
            delete: {
              handler: (item) => {
                handleDelete(item.id.data, deleteDepartment, {
                  successMessage: "Department deleted successfully!",
                  errorMessage: "Failed to delete department!",
                });
              },
              show: commonConditions.nonSystemGenerated,
            },
            edit: {
              handler: (item) => {
                openModal(item, actions_type.ADD_EDIT);
                const InitialData = {
                  id: item.id.data,
                  name: item?.name.data,
                  abrv: item.abbreviation.data,
                  description: item.description.data,
                  parentId: item.parentId?.data || item.parent_id?.data || null,
                };
                setIsEditValue(InitialData);
              },
              show: commonConditions.nonSystemGenerated,
            },
           
          },
          {
            systemGeneratedBadge: true,
            badgeText: "System Generated",
            badgeVariant: "info",
          }
        )
    ),
  });

  const TableHeaderData = [
    {
      label: "Name",
      key: "name",
    },
    {
      label: "Abbreviation",
      key: "abbreviation",
    },
    {
      label: "Description",
      key: "description",
    },
    {
      label: "Created At",
      key: "createdAt",
    },
    {
      label: "Status",
      key: "status",
    },
  ];

  // Get parent department options (exclude current department when editing)
  const parentDepartmentOptions = useMemo(() => {
    if (!departments || !Array.isArray(departments)) {
      return [];
    }
    const deptList = departments;
    // Filter out current department if editing to prevent circular reference
    if (isEditValue?.id) {
      return deptList.filter((dept) => dept.value !== isEditValue.id);
    }
    return deptList;
  }, [departments, isEditValue?.id]);

  // Comprehensive form fields
  const comprehensiveFields = useMemo(() => [
    // Basic text fields
    {
      name: "name",
      label: "Department Name",
      type: "text",
      placeholder: "Enter department name",
      required: true,
      minLength: 3,
      maxLength: 40,
    },
    {
      name: "abrv",
      label: "Abbreviation",
      type: "text",
      required: true,
      placeholder: "Enter abbreviation",
      minLength: 2,
      maxLength: 10,
    },
    {
      name: "parentId",
      label: "Parent Department (Optional)",
      type: "select",
      placeholder: "Select parent department",
      options: parentDepartmentOptions,
      required: false,
    },
    // Textarea
    {
      name: "description",
      label: "Description",
      type: "textarea",
      // required: true,
      placeholder: "Write description here...",
      maxLength: 300,
    },
  ], [parentDepartmentOptions]);

  // Handle form submission
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    // Prepare form data - convert empty parentId to null
    const formData = {
      ...values,
      parentId: values.parentId || null,
    };

    // Edit
    if (isEditValue) {
      const response = await handleUpdate(
        formData,
        isEditValue.id,
        updateDepartment,
        {
          successMessage: "Department updated successfully!",
          errorMessage: "Failed to update department!",
        }
      );
      if (response.success) {
        setIsEditValue(null);
        closeModal();
      }
    } else {
      // Create new
      const response = await handleCreate(formData, createDepartment, {
        successMessage: "Department created successfully!",
        errorMessage: "Failed to create department!",
      });
    }

    setSubmitting(false);
    // setTimeout(() => {
    //   resetForm();
    //   setIsEditValue(null);
    // }, 2000);
  };

  // Handle form cancellation
  const handleCancel = () => {
    setIsEditValue(null);
    closeModal();
  };

  // Handle drawer close
  const handleDrawerClose = (isOpen) => {
    if (!isOpen) {
      handleCancel();
    }
  };

  // Toggle component for delete visibility

  return (
    <div className={"flex flex-col gap-2"}>
      {/* <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
        shorting
        sortingModule="department"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
        // buttons={<DeleteToggle />}
      /> */}

      <PageTableHeader
        isSearch
        onSearchChange={handleSearchChange}
        add
        onClickAdd={() => openModal("", actions_type.ADD_EDIT)}
        shorting
        sortingModule="department"
        onSortingChange={sortingUIProps?.onSortingChange}
        sortingProps={sortingUIProps}
        breadcrumbs={items}
        // buttons={<DeleteToggle />}
      />

      <div className={"flex flex-col gap-2"}>
        <CommonTable
          search={search}
          TableHeaderData={TableHeaderData}
          tabledata={tableData.data}
          currentPage={currentPage}
          totalData={totalData}
          setCurrentPage={handlePageChange}
          loading={loading}
          action={tableData.action}
          showActions={true}
        />

        <BottomDrawer
          isOpen={action === actions_type.ADD_EDIT}
          setIsOpen={handleDrawerClose}
          title={isEditValue ? "Edit Department" : "Add Department"}
          size="500px"
          position="right"
        >
          <CommonForm
            fields={comprehensiveFields}
            initialData={isEditValue ? isEditValue : {}}
            onSubmit={handleSubmit}
            submitButtonText="Submit"
            onCancel={handleCancel}
            cancelButtonText="Cancel"
            columnsPerRow={1}
            gap="gap-4"
            rowClassName=""
            fieldClassName="bg-white p-3 rounded shadow-sm"
          />
        </BottomDrawer>
      </div>
    </div>
  );
};
export default ManageDepartment;
